import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import {CommonModule} from "@angular/common";
import {SharedModule} from "@app/modules/shared/shared.module";
import {MaterialDetailFilterComponent} from "./material/components/material-detail-filter/material-detail-filter.component";
import {ListboxModule} from "primeng/listbox";
import {MaterialListComponent} from "@dashboard/modules/material-management/material/components/material-list/material-list.component";
import {MaterialFormComponent} from "@dashboard/modules/material-management/material/components/material-form/material-form.component";
import {UnitFormComponent} from "@dashboard/modules/material-management/unit/components/unit-form/unit-form.component";
import {UnitListComponent} from "@dashboard/modules/material-management/unit/components/unit-list/units-list.component";
import {UnitSetListComponent} from "@dashboard/modules/material-management/unit-set/components/unit-set-list/unit-set-list.component";
import {UnitSetFormComponent} from "@dashboard/modules/material-management/unit-set/components/unit-set-form/unit-set-form.component";
import {SidebarModule} from "primeng/sidebar";
import {ProductLicenseFormComponent} from "./product-license/components/product-license-form/product-license-form.component";
import {ProductLicenseListComponent} from "./product-license/components/product-license-list/product-license-list.component";
import {ProductLicenseDetailFilterComponent} from "./product-license/components/product-license-detail-filter/product-license-detail-filter.component";
import {ProductLicenseHistoryComponent} from "./product-license/components/product-license-history/product-license-history.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LicenseDocumentsReportComponent} from "./reports/license-documents-report/license-documents-report.component";

@NgModule({
  imports: [CommonModule, ListboxModule, SidebarModule, SharedModule],
  declarations: [
    MaterialListComponent,
    MaterialFormComponent,
    UnitFormComponent,
    UnitListComponent,
    UnitSetListComponent,
    UnitSetFormComponent,
    MaterialDetailFilterComponent,
    ProductLicenseFormComponent,
    ProductLicenseListComponent,
    ProductLicenseDetailFilterComponent,
    ProductLicenseHistoryComponent,
    LicenseDocumentsReportComponent,
  ],
  exports: [
    MaterialListComponent,
    MaterialFormComponent,
    UnitFormComponent,
    UnitListComponent,
    UnitSetListComponent,
    UnitSetFormComponent,
    ProductLicenseFormComponent,
    ProductLicenseListComponent,
    ProductLicenseDetailFilterComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class MaterialManagementModule {}
